<template>
  <van-row id="intro" class="flex-column">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <!-- title part -->
    <van-skeleton class="mt-4rem" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <van-divider class="mt-4rem" style="font-size: 1.2rem;">会员单位</van-divider>
    </van-skeleton>

    <!-- search part -->
    <van-skeleton style="margin-top: 1rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title">
      <form action="/">
        <van-search
          v-model.trim="skey"
          show-action
          placeholder="请输入搜索关键字"
          @search="onSearch"
          @cancel="onCancel"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </form>
    </van-skeleton>

    <!-- popup content -->
    <van-popup content v-model="show" style="width: 80%; border-radius: 0.3rem; padding: 1rem;">
      <van-divider>会员信息</van-divider>
      <van-cell v-for="(item,index) in searchList" :key="item.id" :title="item.name" :value="item.levelName" :label="item.company" />
    </van-popup>

    <!-- member list part -->
    <van-skeleton style="margin-top: 1rem;" title title-width="100%" :row="0" :loading="sloading" id="skeleton-title"></van-skeleton>
    <van-skeleton :row="10" :loading="sloading" style="margin-top: 0.5rem;" id="skeleton-cell">
      <van-tabs v-model="active" border @click="tabClick">
        <van-tab title="个人会员">
          <van-list
            v-if="memberList.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
          >
            <van-cell v-for="(item,index) in memberList" :key="item.id" :title="item.name" :value="item.levelName" :label="item.company" />
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
        <van-tab title="单位会员">
          <van-list
            v-if="memberList.length > 0"
            :v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
          >
            <van-cell v-for="(item,index) in memberList" :key="item.id" :title="item.name" :value="item.levelName" />
          </van-list>
          <van-empty v-else description="暂无记录" />
        </van-tab>
      </van-tabs>
    </van-skeleton>


    <!-- footer part -->
    <!-- <myfooter></myfooter> -->

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
// import footer from '@/view/footer/footer'

import { Toast } from 'vant';

const axios = require('axios')

export default {
  name: 'intro',
  components: {
    'mynavbar' : navbar,
    // 'myfooter' : footer
  },
  data () {
    return {
      skey: '',
      active: 0,
      show: false,
      loading: false,
      sloading: true,
      finished: false,
      memberList: [],
      searchList:[],
      currPage: 1,
      tabId: 0
    }
  },
  mounted() {
    this.getMembers(this.tabId,this.currPage)
  },
  methods: {
    // 加载更多
    onLoad() {
      console.log("加载更多")
      this.currPage = this.currPage + 1
      this.getMembers(this.tabId,this.currPage)
    },

    // tab点击触发
    tabClick (name,title) {
      this.currPage = 1
      this.loading = true
      this.finished = false
      this.tabId = name
      this.memberList = []
      this.getMembers(name,this.currPage)
    },
    // 获取会员s列表
    getMembers (id,page) {
      let that = this
      // that.loading = true
      axios.get(that.global.apiUrl + '/web/member/list?page='+page+'&limit=10&type='+id+'&sort=id&order=desc')
        .then(function (response) {
          if (response.data.success && response.data.data.records.length > 0) {
            var memberList = response.data.data.records
            for (var i in memberList) {
              const item = memberList[i]
              var str = ""
              switch(item.level){
                case "0":
                  str = "会员"
                  break;
                case "1":
                  str = "理事"
                  break;
                case "2":
                  str = "常务理事"
                  break;
                case "3":
                  str = "副会长"
                  break;
                default:
                  break;
              }
              item.levelName = str
              // console.log(item.levelName)
              // item.digest = item.title
              // item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
              // item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
              // memberList数组追加
              that.memberList.push(memberList[i])
            }
            // that.memberList = memberList
            // console.log(that.memberList);
            // 加载状态结束
            that.loading = false
            that.sloading = false
          }else {
            that.sloading = false
            // that.memberList = []
            that.loading = false
            that.finished = true
          }
          // console.log(that.memberList)
        }
      )
    },

    onSearch(val) {
      // console.log(val)
      // console.log(this.skey)
      if(this.skey.length <= 0 || this.skey == '' || this.skey == null) {
        Toast.fail({
          message: '搜索不能为空',
          duration: 2000,
        })

        return false
      }
      let that = this
      // that.loading = true
      axios.get(that.global.apiUrl + '/web/member/list?page=1&limit=10&name='+this.skey+'&sort=id&order=desc')
        .then(function (response) {
          if (response.data.success && response.data.data.records.length > 0) {
            that.searchList = response.data.data.records
            // that.loading = false
            for (var i in that.searchList) {
              const item = that.searchList[i]
              var str = ""
              switch(item.level){
                case "0":
                  str = "会员"
                  break;
                case "1":
                  str = "理事"
                  break;
                case "2":
                  str = "常务理事"
                  break;
                case "3":
                  str = "副会长"
                  break;
                default:
                  break;
              }
              item.levelName = str
              // console.log(item.levelName)
              // item.digest = item.title
              // item.title = item.title.length > 20 ? item.title.substring(0, 20) + '...' : item.title
              // item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
            }
            that.show = true
          }else {
            that.searchList = []
            Toast.fail({
              message: '暂无记录',
              duration: 2000,
            })
            that.show = false
            // that.searchList = [{name: '无记录'}]
            // that.loading = false
            // that.finished = true
          }
          // console.log(that.memberList)
        }
      )

      // this.show = true
    },
    onCancel() {

    },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/view/member/member.vue